module.exports = __webpack_public_path__ + "img/3_155.301e0ffb.png";